export default "__VITE_PUBLIC_ASSET__1a5f58f9__"